<template>
  <div class="app-container">
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <BjFormItemCode v-model="queryParams.code" :label="$t('BusinessPurchaseSupplier.header.code')" prop="code" @keyup.enter.native="handleQuery" />
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseSupplier.header.name')" prop="name">
            <BjInput v-model="queryParams.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="status">
            <BjSelectLov v-model="queryParams.status" :option-list="STATUS_ENABLED_TRUE" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseSupplier.header.classify')" prop="type">
            <BjInput v-model="queryParams.type" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:BusinessPurchaseSupplierIndex_Add type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button>
          <el-button v-permission:BusinessPurchaseSupplierIndex_ExcelImport @click="onImport">{{ $t('BusinessPurchaseSupplier.export.excelImport') }}</el-button>
          <el-button v-permission:BusinessPurchaseSupplierIndex_Export @click="onExport">{{ $t('BusinessPurchaseSupplier.export.export') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="{ row }">
              <template v-if="false" />

              <el-tag v-else-if="col.prop === 'status'" :type="row[col.prop] ? 'success' : 'info'">{{ $t(STATUS_ENABLED_TRUE.bjGet(row[col.prop])) }}</el-tag>
              <template v-else-if="col.prop === 'invoiceType'">
                {{ SPUR_INVOICE_TYPE.bjGet(row[col.prop]) }}
              </template>
              <template v-else-if="col.prop === 'cycleDay' && row[col.prop]">
                {{ row[col.prop] }}{{ $t('BusinessPurchaseSupplier.dataForm.day') }}
              </template>
              <template v-else-if="['overfillRate', 'taxRate'].includes(col.prop)">
                {{ row[col.prop] }}%
              </template>
              <template v-else-if="col.prop === 'contactAddress'">
                {{ (row.contactProvince || '') + (row.contactCity || '') + (row.contactDistrict || '') + (row[col.prop] || '') }}
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="{ row }">
              <el-button v-permission:BusinessPurchaseSupplierIndex_Edit type="text" class="edit-btn" @click="onEdit(row)">{{ $t('editText') }}</el-button>
              <el-button v-permission:BusinessPurchaseSupplierIndex_Status type="text" @click="onStatus(row)">{{ row.status ? $t('disableText') : $t('enableText') }}</el-button>
              <el-button v-permission:BusinessPurchaseSupplierIndex_Delete type="text" :disabled="row.status" @click="onDelete(row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
    <BjExcelImportDialog ref="ExcelImport" :download-name="$t('BusinessPurchaseSupplier.export.title')" href="/供应商导入模板.xlsx" template-code="SPUR.SUPPLIER_IMPORT">
      {{ $t('BusinessPurchaseSupplier.export.rules') }}：<br /> 1.{{ $t('BusinessPurchaseSupplier.export.p1') }}；<br /> 2.{{ $t('BusinessPurchaseSupplier.export.p2') }}：
      <el-button type="primary" @click="$refs.ExcelImport.onDownload()">{{ $t('BusinessPurchaseSupplier.export.title') }}</el-button><br /> 3.{{ $t('BusinessPurchaseSupplier.export.p3') }}<br /> 4.{{ $t('BusinessPurchaseSupplier.export.p4') }}
    </BjExcelImportDialog>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { purchaseApi } from '@/api';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
import { downloadBlob } from '@/utils/index';

export default {
  name: 'BusinessPurchaseSupplier',
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_TRUE,
      queryApi: purchaseApi.getSuppliers,
      // 查询参数
      queryParams: {
        code: null,
        name: null,
        status: null,
        type: null,
      },
      labelsVersion: 0,
      labelList: [
        { label: 'BusinessPurchaseSupplier.table.code', prop: 'code', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.name', prop: 'name', isCheck: true, disabled: false, width: '160' },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: 'BusinessPurchaseSupplier.table.classify', prop: 'type', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessPurchaseSupplier.table.supplierGrade', prop: 'level', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessPurchaseSupplier.table.proportion', prop: 'overfillRate', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessPurchaseSupplier.table.week', prop: 'cycleDay', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessPurchaseSupplier.table.invoicing', prop: 'invoiceType', isCheck: true, disabled: false, width: '120' },
        { label: 'BusinessPurchaseSupplier.table.taxRate', prop: 'taxRate', isCheck: true, disabled: false, width: '135' },
        { label: 'BusinessPurchaseSupplier.table.paymentMethod', prop: 'paymentType', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.company', prop: 'fullName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.mnemonicCode', prop: 'mnemonic', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.cooperationDate', prop: 'cooperationDate', isCheck: true, disabled: false, width: '140' },
        { label: 'BusinessPurchaseSupplier.table.contactPerson', prop: 'contactName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.telephone', prop: 'contactTel', isCheck: true, disabled: false, width: '120' },
        { label: 'BusinessPurchaseSupplier.table.phone', prop: 'contactPhone', isCheck: true, disabled: false, width: '100' },
        { label: 'BusinessPurchaseSupplier.table.address', prop: 'contactAddress', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.email', prop: 'contactEmail', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.account', prop: 'bankName', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.bankOfDeposit', prop: 'bankDeposit', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.bankAccount', prop: 'bankAccount', isCheck: true, disabled: false, width: '160' },
        { label: 'BusinessPurchaseSupplier.table.remark', prop: 'remark', isCheck: true, disabled: false, width: '160' },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: '140' },
        { label: 'table.creatorText', prop: 'createdName', isCheck: true, disabled: false, width: '120' },
        { label: 'BusinessPurchaseSupplier.table.changeTime', prop: 'lastUpdateDate', isCheck: true, disabled: false, width: '140' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
      ],
      selection: false,
    };
  },
  computed: {
    SPUR_INVOICE_TYPE() {
      return this.$store.state.values.SPUR_INVOICE_TYPE || [];
    },
  },
  watch: {},
  mounted() {
    this.$store.dispatch('values/getValueList', 'SPUR.INVOICE_TYPE');
  },
  methods: {
    onAdd() {
      this.$refs.DataForm.show();
    },
    onEdit(row) {
      const { id, code } = row;
      purchaseApi.getSuppliersDetail({ id, code }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$refs.DataForm.show(this.$lodash.clone(res));
        }
      });
    },
    onStatus(row) {
      this.$MessageBox({
        content: `${this.$t('toast.youAreTipText')} ${this.$t(
          this.STATUS_ENABLED_TRUE.bjGet(row.status ? 0 : 1),
        )} ${row.name}，${this.$t('toast.continueTipText')}`,
      }).then(() => {
        this.operationApi({
          ...row,
          status: row.status ? 0 : 1,
        });
      });
    },
    onDelete(row) {
      this.$MessageBox({ content: this.$t('toast.deletionConfirmationText') }).then(() => {
        const { id, objectVersionNumber } = row;
        this.batchDeleteApi({
          ids: [{ id, objectVersionNumber }],
        });
      });
    },
    onImport() {
      this.$refs.ExcelImport.show();
    },
    /** 导出 */
    onExport() {
      purchaseApi.reportSuppliers(this.queryParams).then(res => {
        downloadBlob(
          res,
          this.$t('BusinessPurchaseSupplier.export.downLoadName') +
            new Date().toLocaleString() +
            '.xlsx',
        );
      });
    },
    batchDeleteApi(ids) {
      purchaseApi.deleteSuppliers(ids).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    operationApi(DATA) {
      purchaseApi.putSuppliers(DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
